import { render, staticRenderFns } from "./honors-wall.vue?vue&type=template&id=62c42634&scoped=true"
import script from "./honors-wall.vue?vue&type=script&lang=js"
export * from "./honors-wall.vue?vue&type=script&lang=js"
import style0 from "./honors-wall.vue?vue&type=style&index=0&id=62c42634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c42634",
  null
  
)

export default component.exports